// dev_lp — respects the site-wide accessibility "no animations" preference.
// Mirrors the original LandingPage behavior: watches body for the
// "accessibility-no-animations" class and returns whether animations are allowed.

import { useEffect, useState } from "react";

export const useShouldAnimate = (): boolean => {
  const [shouldAnimate, setShouldAnimate] = useState(true);

  useEffect(() => {
    const check = () =>
      setShouldAnimate(
        !document.body.classList.contains("accessibility-no-animations"),
      );
    check();
    const observer = new MutationObserver(check);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });
    return () => observer.disconnect();
  }, []);

  return shouldAnimate;
};
